import { Box, CircularProgress, Container, Skeleton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MenuAyudantia } from "../../components/MenuPrincipal";

export const PantallaCargaPage: React.FC<{}> = () => {
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                <CircularProgress />
            </Box>
            {/* <Stack spacing={2}>
                <Skeleton variant="text" width={210} height={30} />
                <Skeleton variant="rectangular" width="100%" height={100} />
                <Skeleton variant="circular" width={40} height={40} />
            </Stack> */}
        </Container>
    )
}